module.exports = function() {
  return new Worker(__webpack_public_path__ + "5af79820e7f0e7318137.worker.js");
};